import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactTouchEvents from 'react-touch-events';
import style from '../css/videoPlayer.css';
//constants
import {VIRTUALS} from '../../../../constants/games';
// import {ASSETS_URL} from '../../../../constants/endpoints';
//actions
import {selectGame} from '../../../../actions/gamesActions';
//helpers
// import {hasEventTypeRacerNumberUI} from '../../modules/racing/helpers/racersHelper';
import Attracts from '../../sharedComponents/components/attracts'

const CONSTS = require('../../../../constants/communications');

const mapStateToProps = (state, ownProps) => {
    return {selectedGameIndex: state.vpp.selectedGameIndex, events: state.vpp.events, games: state.vpp.games};
};

class VideoPlayer extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        let videoWidth = window.innerWidth * 0.85;

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            events: storeData.vpp.events,
            games: storeData.vpp.games,
            width: videoWidth,
            height: (videoWidth * 9) / 16
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this._setDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._setDimensions.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState({
            ...this.state,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            events: storeData.vpp.events,
            games: storeData.vpp.games
        });
    }

    _setDimensions() {
        let videoWidth = window.innerWidth * 0.85;

        this.setState({
            ...this.state,
            width: videoWidth,
            height: (videoWidth * 9) / 16
        });
    }

    _prev() {
        let previousGameIndex;
        if (this.state.selectedGameIndex === 0) {
            previousGameIndex = VIRTUALS.length - 1;
        } else {
            previousGameIndex = this.state.selectedGameIndex - 1;
        }
        this.props.store.dispatch(selectGame(previousGameIndex, this.props.store));
    }

    _next() {
        let nextGameIndex;
        if (this.state.selectedGameIndex === VIRTUALS.length - 1) {
            nextGameIndex = 0;
        } else {
            nextGameIndex = this.state.selectedGameIndex + 1;
        }
        this.props.store.dispatch(selectGame(nextGameIndex, this.props.store));
    }

    _swipeGames(direction) {
        switch (direction) {
            case 'left':
                this._next();
                break;
            case 'right':
                this._prev();
                break;
            default:
                break;
        }
    }

    render() {
        // let store = this.props.store;
        // let storeData = store.getState();
        let videoWidth = window.innerWidth * 0.85;
        // let sliderContent;

        // let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        // let sliderRacers;
        // if (this.state.events && this.state.events.length > 0 && this.state.events[0].racers && this.state.events[0].racers.length > 0) {
        //   sliderRacers = this.state.events[0].racers.map((racer, index) => <div key={index} className={style.sliderRacer}>
        //     <div id={'slider_racer_silk_' + racer.num} className={style.racerIconContainer}>
        //       {
        //         hasEventTypeRacerNumberUI(selectedEvent.eventType)
        //           ? (<div id={'slider_racer_number_' + racer.num} className={style.racerNumber}>{racer.num}</div>)
        //           : ''
        //       }
        //       <img src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(racer.silk) + 1}.png`} className={style.racerIcon} alt={`icon${racer.silk}`}/>
        //     </div>
        //     <div className={style.sliderText}>{' ' + racer.name + ' $' + racer.oddsFirst}</div>
        //   </div>);
        // }

        // if (sliderRacers && sliderRacers.length > 0) {
        //   sliderContent = (<div className={style.slider}>
        //     <div className={style.sliderContent} style={{
        //         animation: `${style.marquee} ${ 3 * this.state.events[0].racers.length}s linear infinite`
        //       }}>{sliderRacers}</div>
        //   </div>);
        // }

        let attracts;
        if (this.state.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.RES) {
            attracts = '';
        } else {
            attracts = (<Attracts store={this.props.store}/>);
        }

        return (<ReactTouchEvents onSwipe={this._swipeGames.bind(this)}>
            <div className={style.videoContainer}>

                <div style={{
                    position: 'relative',
                    overflow: 'hidden',
                    width: videoWidth,
                    height: (videoWidth * 9) / 16
                }}>
                    <iframe className={style.iframe} src={VIRTUALS[this.state.selectedGameIndex].URL.VIDEO_URL}
                            frameBorder='0' title={VIRTUALS[this.state.selectedGameIndex].name}/>
                    {/* {sliderContent} */}
                    {attracts}
                </div>
            </div>
        </ReactTouchEvents>);
    }
}

export default connect(mapStateToProps)(VideoPlayer);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/containers/videoPlayer.js